export const SPACING = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};
